<!--
 @description 自定义到期提醒
 @author xiehan
 @date 2020/02/20
-->
<template>
    <div class="customExpiration__content">
      <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="auto">
        <el-form-item :label="$t('logComponentManage.site')">
          <g-select :list="siteList" v-model="searchForm.siteCode"></g-select>
        </el-form-item>
        <el-form-item :label="$t('customExpiration.group')">
          <g-select :list="select_group" v-model="searchForm.group" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('customExpiration.name')">
          <el-input v-model="searchForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('customExpiration.type')">
          <g-select :list="select_type" v-model="searchForm.type" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('customExpiration.expireTime')" input-width="auto">
          <el-form-item prop="startTime">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="datetime">
            </el-date-picker>
          </el-form-item>
          <span v-text="$t('common.to')"></span>
          <el-form-item prop="endTime" style="margin-left: 10px">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="datetime">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item input-width="auto">
          <el-button type="primary" 
            v-g-rac="gRac('customExpiration@search')"
            @click="search"
            v-text="$t('common.search')"></el-button>
          <el-button type="primary" 
            v-g-rac="gRac('customExpiration@add')"
            @click="addOperation"
            v-text="$t('common.add')"></el-button>
          <el-button type="primary" 
            v-g-rac="gRac('customExpiration@delete')"
            @click="deleteOperation"
            v-text="$t('customExpiration.batchDelete')"></el-button>
          <el-button type="primary" 
            v-g-rac="gRac('customExpiration@export')"
            @click="e_export"
            v-text="$t('accidentEntry.export')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="tData" 
        :head="tHead" 
        :currentChange="tCurrentChange" 
        :sizeChange="tSizeChange"
        :selection="true"
        :selectionChange="multiSelect"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="tableControl" 
            :data="data" 
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <el-dialog :closeOnClickModal="false"
        :title="expirationDiaTitle"
        :visible.sync="expirationDiaVis"
        width="400px">
        <el-form ref="handleForm" :model="handleForm" input-width="180px" label-width="80px" :rules="rules">
          <el-form-item :label="$t('customExpiration.group')" prop="group">
            <g-select v-model="handleForm.group" :list="select_group"></g-select>
          </el-form-item>
          <el-form-item :label="$t('customExpiration.name')" prop="name">
            <el-input v-model="handleForm.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('customExpiration.type')" prop="type">
            <g-select v-model="handleForm.type" :list="select_type"></g-select>
          </el-form-item>
          <el-form-item :label="$t('customExpiration.operator')" prop="operator">
            <el-input v-model="handleForm.operator"></el-input>
          </el-form-item>
          <el-form-item :label="$t('customExpiration.updateTime')" prop="updateTime">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="handleForm.updateTime" type="datetime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('customExpiration.expireTime')" prop="expireTime">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="handleForm.expireTime" type="datetime">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('customExpiration.remarks')" prop="remarks">
            <el-input v-model="handleForm.remarks"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="expirationDiaVis = false" v-text="$t('common.cancel')"></el-button>
          <el-button type="primary" @click="expirationDiaConfirm" v-text="$t('common.submit')"></el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
    import SiteListBiz from '@/logic/cmdb/cmdbBiz'
    import dic from '@/components/mixins/dic'
    import table from '@/components/mixins/table'
    import exportTips from '@/components/mixins/exportTips'
    import rac from '@/plugins/rac-mixin.js'
    import customExpirationBiz from '@/logic/systemDiagram/customExpirationBiz.js'
    import { extend } from '@/utils/tool'
    import TimeFormat from '@/utils/timeFormat'
    const DIC_MAP = {
      group: 'recordmoduletype',
      level: 'riskleveltype'
    }
    export default {
      mixins: [dic, table, rac, exportTips],
      data () {
        return {
          siteList: {},
          select_type: {},
          select_group: {},
          selects: [],
          doExport: null,
          searchForm: {
            siteCode: '',
            startTime: new Date(new Date().toLocaleDateString()).getTime(),
            endTime: '',
            group: '',
            name: '',
            type: ''
          },
          handleForm: {
            group: '',
            name: '',
            type: '',
            operator: '',
            updateTime: '',
            expireTime: '',
            remarks: '',
          },
          rules: {},
          tableControl: [
            {
              label: this.$t('common.edit'),
              callback: (row, index, data) => {
                this.expirationDiaVis = true
                this.expirationDiaTitle = this.$t('common.edit')
                this.selectId = row.id
                for (let i in this.handleForm) {
                  this.handleForm[i] = row[i]
                }
                this.handleForm.updateTime = TimeFormat.formatTimeTolong(this.handleForm.updateTime)
                this.handleForm.expireTime = TimeFormat.formatTimeTolong(this.handleForm.expireTime)
                this.handleForm.group = Object.keys(this.select_group)
                  .filter(item => this.select_group[item] === this.handleForm.group)[0]
                this.handleForm.type = Object.keys(this.select_type)
                  .filter(item => this.select_type[item] === this.handleForm.type)[0]
              },
              rac: () => this.gRac('customExpiration@edit')
            }, {
              label: this.$t('common.delete'),
              callback: (row, index, data) => {
                this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
                  confirmButtonText: this.$t('common.confirm'),
                  cancelButtonText: this.$t('common.cancel'),
                  type: 'warning'
                }).then(() => {
                  customExpirationBiz.delete({ id: row.id, siteCode: this.searchForm.siteCode }).then(() => {
                    this.successMessage()
                    this.searchTable()
                  })
                }).catch(() => {})
              },
              rac: () => this.gRac('customExpiration@delete')
            }
          ],
          expirationDiaTitle: '',
          expirationDiaVis: false
        }
      },
      methods: {
        async preInitTable () {
          await Promise.all([
            this.dGetDictionaryByCode('credentialstype'),
            this.dGetDictionaryByCode('businessmoduletype')
          ])
          this.select_type = { ...this.dDictionary.credentialstype }
          this.select_group = { ...this.dDictionary.businessmoduletype }
          this.initTable()
          this.setRules()
        },
        getSiteList () {
          SiteListBiz.siteList({perPageCount: 500}).then((data) => {
            let list = {}
            data.dataList.map((item) => {
              list[item.siteCode] = item.name
            })
            this.siteList = list
            this.searchForm.siteCode = Object.keys(this.siteList)[0]
            this.preInitTable()
            this.searchTable()
          })
        },
        initTable () {
          this.tInitTable({
            lanKey: 'customExpiration.table',
            head: ['group', 'name', 'type', 'operator', 'updateTime', 'expireTime', 'opTime', 'remarks'],
            requestFun: this.searchTable,
            headOpt: {
                group: {
                formatter: 'Dictionary',
                formatterDic: this.select_group
              },
              type: {
                formatter: 'Dictionary',
                formatterDic: this.select_type
              }
            }
          })
        },
        search () {
          this.tResetPage()
          this.searchTable()
        },
        searchTable () {
          const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
          if (!reqData.endTime) reqData.endTime = new Date().getTime()
          if (!reqData.type) reqData.type = 0
          customExpirationBiz.query(reqData).then((data) => {
            if (data && data.dataList) {
              data.dataList.map(item => {
                item.updateTime = TimeFormat.getFormatTime(item.updateTime)
                item.expireTime = TimeFormat.getFormatTime(item.expireTime)
                item.opTime = TimeFormat.getFormatTime(item.opTime)
              })
            }
            this.tData = data
          })
        },
        setRules () {
          for (let i in this.handleForm) {
            this.rules[i] = [
              { required: true, message: `${this.$t('common.entryTips')}${this.$t('customExpiration.' + i)}` }
            ]
          }
          delete this.rules.remarks
        },
        addOperation () {
          this.expirationDiaTitle = this.$t('common.add')
          this.expirationDiaVis = true
          for (let i in this.handleForm) {
            this.handleForm[i] = ''
          }
          this.$nextTick(() => {
            this.$refs['handleForm'].clearValidate()
          })
        },
        expirationDiaConfirm () {
          this.$refs['handleForm'].validate((valid) => {
            if (valid) {
              let eventName = this.expirationDiaTitle === this.$t('common.edit')
                ? 'update' : 'save'
              let saveObj = extend(true, {}, this.handleForm)
              saveObj.siteCode = this.searchForm.siteCode
              if (this.expirationDiaTitle === this.$t('common.edit')) saveObj.id = this.selectId
              customExpirationBiz[eventName](saveObj).then(data => {
                this.expirationDiaVis = false
                this.successMessage()
                this.searchTable()
              })
            } else {
              return false
            }
          })
        },
        multiSelect (val) {
          this.selects = val
        },
        successMessage () {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
        },
        deleteOperation () {
          if (this.selects && this.selects.length > 0) {
            this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
              confirmButtonText: this.$t('common.confirm'),
              cancelButtonText: this.$t('common.cancel'),
              type: 'warning'
            }).then(() => {
              let selected = []
              this.selects.map(item => {
                selected.push(item.id)
              })
              customExpirationBiz.deleteBatch({ ids: selected, siteCode: this.searchForm.siteCode }).then((data) => {
                this.successMessage()
                this.searchTable()
              })
            }).catch(() => {})
          } else {
            this.$message({
              message: this.$t('ALBTargetGroupManager.selectTips'),
              type: 'warning'
            })
          }
        },
        e_export () {
          const search = extend({}, this.searchForm)
          if (!search.endTime) search.endTime = new Date().getTime()
          if (!search.type) search.type = 0
          if (!this.doExport) this.doExport = this.exportOperation()
          this.doExport(search)
        },
        exportOperation () {
          const that = this
          const list = Object.assign({}, that.$t('customExpiration.table'))
          const dictionary = []
          for (const key in DIC_MAP) {
            dictionary.push({
              relate: key,
              type: that.dDictionary[DIC_MAP[key]]
            })
          }
          return function (search) {
            that.exRenderBefore()
            customExpirationBiz.export(
              list,
              search,
              ['opTime', 'updateTime', 'expireTime'],
              dictionary,
              that.exRenderTips,
              that.exRenderFail
            )
          }
        }
      },
      mounted () {
        this.getSiteList()
      }
    }
  </script>
  
  <style scoped>
  </style>